export var OutstreamEnum;
(function (OutstreamEnum) {
    OutstreamEnum[OutstreamEnum["aditude"] = 0] = "aditude";
    OutstreamEnum[OutstreamEnum["kargo"] = 1] = "kargo";
    OutstreamEnum[OutstreamEnum["exco"] = 2] = "exco";
    OutstreamEnum[OutstreamEnum["off"] = 3] = "off";
    OutstreamEnum[OutstreamEnum["house"] = 4] = "house";
})(OutstreamEnum || (OutstreamEnum = {}));
;
export var RequestType;
(function (RequestType) {
    RequestType["parallel"] = "parallel";
    RequestType["sequential"] = "sequential";
    RequestType["scattered"] = "scattered";
})(RequestType || (RequestType = {}));
export var Floors;
(function (Floors) {
    Floors["none"] = "";
    Floors["aditude"] = "aditude";
})(Floors || (Floors = {}));
export var VideoType;
(function (VideoType) {
    VideoType["prebid"] = "prebid";
    VideoType["h5"] = "h5";
    VideoType["exco"] = "exco";
})(VideoType || (VideoType = {}));
export var PrebidServerVendor;
(function (PrebidServerVendor) {
    PrebidServerVendor["appnexus"] = "appnexus";
    PrebidServerVendor["openx"] = "openx";
    PrebidServerVendor["rubicon"] = "rubicon";
})(PrebidServerVendor || (PrebidServerVendor = {}));
